import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {AppLocalStorage} from "app/app-storage-manager/local-storage";
import {AuthHeaderService} from "app/shared/auth-header.service";
import {MiscService} from "app/shared/misc.service";
import {environment} from "environments/environment";
import {Observable} from "rxjs";
import {map, retry, tap} from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class SettingsService {
    constructor(
        private http: HttpClient,
        private miscService: MiscService,
        private authHeaderService: AuthHeaderService
    ) {
        this.constantsHeaders = new HttpHeaders()
        .set("X-APP-ID", `${environment.X_APP_ID}`)
        .set("X-ISSUER-ID", `${environment.X_ISSUER_ID}`);
    }
    private readonly constantsHeaders: HttpHeaders;

    private generateDynamicHeader(payload: any): HttpHeaders {
        const xAuthHeader = this.authHeaderService.generateAuthHeader(payload);
        return new HttpHeaders().set("X-Auth-Signature", xAuthHeader);
    }
    private mergeHeaders(dynamicHeader: HttpHeaders): HttpHeaders {
        return this.constantsHeaders.append("X-Auth-Signature", dynamicHeader.get("X-Auth-Signature"));
    }

    changeBusinessName = (requestBody) =>
        this.http.put(
            `${environment.API_URL}/merchant/name/${this.miscService.getMerchantDetails().merchant_id}`,
            requestBody
        );

    changePassword = (requestBody) =>
        this.http.put(`${environment.API_URL}/merchant/password/${localStorage.getItem("session_id")}`, requestBody);

    // getAccountStatement (from: string, to: string, account_id: string, iso: string, download: boolean = false): Observable<any> {
    //   return this.http.get(`${environment.API_URL}/transactions/statements/${iso}/${account_id}?from_date=${from}&to_date=${to}&download=${download}`);
    // }
getAccountStatement(
    from: string,
    to: string,
    account_id: string,
    iso: string,
    download: boolean = false,
    is_job: boolean = false,
    email?: string
): Observable<any> {
    const dynamicHeader = this.generateDynamicHeader({});
    const headers = this.mergeHeaders(dynamicHeader);
    
    let params = `?from_date=${from}&to_date=${to}&download=${download}`;
    
    if (is_job) {
        params += `&is_job=true`;
        if (email) {
            params += `&email=${email}`;
        }
    }
    
    return this.http.get(
        `${environment.API_URL2}/xas/v1/transactions/statements/${iso}/${account_id}${params}`,
        {headers}
    );
}
    createUserRoles = (requestBody) => this.http.post(`${environment.API_URL}/merchant/create/role`, requestBody);
    reInviteUser = (merchantId, email) =>
        this.http.post(`${environment.API_URL}/merchant/reinvite/user/${merchantId}/${email}`, {});
    deleteRole = (merchantId, roleId) =>
        this.http.put(`${environment.API_URL}/merchant/update/role/delete/${merchantId}/${roleId}`, {});
    // Sub-user create: POST /asa/users/subuser. Requires the merchant-scoped
    // xcel_token header (captured at login); Authorization Bearer is added by the interceptor.
    createNewUser = (requestBody) =>
        this.http.post(`${environment.API_URL2}/asa/users/subuser`, requestBody, {
            headers: { xcel_token: localStorage.getItem('xcel_token') || '' }
        });
    // Sub-user update: PUT /asa/users/update/{userId}. Requires the merchant-scoped
    // xcel_token header (captured at login); Authorization Bearer is added by the interceptor.
    updateUser = (requestBody) =>
        this.http.put(`${environment.API_URL2}/asa/users/update/${requestBody.user_id}`, requestBody, {
            headers: { xcel_token: localStorage.getItem('xcel_token') || '' }
        });
    // "Update Role" (user role reassignment): PUT /asa/users/update/{userId} with the
    // xcel_token header; Authorization Bearer is added by the interceptor.
    updateUsersRoles = (requestBody) =>
        this.http.put(`${environment.API_URL2}/asa/users/update/${requestBody.user_id}`, requestBody, {
            headers: { xcel_token: localStorage.getItem('xcel_token') || '' }
        });
    updateRoleDetails = (requestBody) =>
        this.http.put(`${environment.API_URL}/merchant/update/role/details`, requestBody);
    // Sub-user delete: DELETE /asa/users/{userId}. Requires the merchant-scoped
    // xcel_token header (captured at login); Authorization Bearer is added by the interceptor.
    deleteUser = (requestBody) =>
        this.http.delete(`${environment.API_URL2}/asa/users/${requestBody.user_id}`, {
            headers: { xcel_token: localStorage.getItem('xcel_token') || '' }
        });
    fetchAllUserRoles = (merchant_id) =>
        this.http.get(`${environment.API_URL}/merchant/fetch/roles/${merchant_id}?status=true`);
    fetchAsaRoles = () => this.http.get(`${environment.API_URL2}/asa/roles`);
    fetchAllUsers = (merchant_id?, page?: any, limit?: any, filter?: string) =>
        this.http.get(`${environment.API_URL2}/asa/users/subusers?page=${page || 1}&limit=${limit || 10}`, {
            headers: { xcel_token: localStorage.getItem('xcel_token') || '' }
        });

    // changePassword = (requestBody) =>
    //   this.http.put(`${environment.API_URL}/merchant/password/${localStorage.getItem('session_id')}`, requestBody);

    validatePassword = (merchantId, email) =>
        this.http.get(`${environment.API_URL}/merchant/user/validate/password/${merchantId}/${email}`);

    // getAccountStatement (from: string, to: string, account_id: string, iso: string, download: boolean = false): Observable<any> {
    //   return this.http.get(`${environment.API_URL}/transactions/statements/${iso}/${account_id}?from_date=${from}&to_date=${to}&download=${download}`);
    // }
    // getAccountStatement(
    //   from: string,
    //   to: string,
    //   account_id: string,
    //   iso: string,
    //   download: boolean = false
    // ): Observable<any> {
    //   const dynamicHeader = this.generateDynamicHeader({});
    //   const headers = this.mergeHeaders(dynamicHeader);
    //   return this.http.get(
    //     `${environment.API_URL3}/transactions/statements/${iso}/${account_id}?from_date=${from}&to_date=${to}&download=${download}`,
    //     { headers }
    //   );
    // }

    exportAccountStatement(
        from: string,
        to: string,
        account_id: string,
        iso: string,
        download: boolean = false
    ): Observable<any> {
        return this.http.get(
            `${environment.API_URL2}/xas/v1/admin/transactions/statements/${iso}/${account_id}?from_date=${from}&to_date=${to}&download=${download}`,
            {responseType: "blob" as "json"}
        );
        // return this.httpClient.post(this.baseUrl(`${routes.report}`), payload, {responseType: 'blob' as 'json'})
    }

    generateAccountStatement = (requestBody, documentType, walletNumber) =>
        this.http.post(
            `${environment.API_URL}/document/${documentType}/account_statement/${walletNumber}`,
            requestBody
        );

    getAppSettings = (countryCode: string, identifier?: string, merchant?: string): Observable<any> => {
        let params = new HttpParams();
        if (countryCode) {
            params = params.set("country_code", countryCode);
        }
        if (merchant) {
            params = params.set("merchant", merchant);
        }
        if (identifier) {
            params = params.set("identifier", identifier);
        }

        return this.http.get(`${environment.API_URL2}/xas/v1/accounts/app_settings`, {params}).pipe(retry(1));
    };
    setupAppSettings = (payload: any): Observable<any> => {
        return this.http.post(`${environment.API_URL2}/xas/v1/accounts/app_settings`, payload);
    };

    updateAppSettings = (payload: any, country_code?: string, identifier?: string, merchant?: string): Observable<any> => {
        let params = new HttpParams();
        if (country_code) {
            params = params.set("country_code", country_code);
        }
        if (merchant) {
            params = params.set("merchant", merchant);
        }
        if (identifier) {
            params = params.set("identifier", identifier);
        }
        return this.http.put(`${environment.API_URL2}/xas/v1/accounts/app_settings`, payload, {params});
    };

    // Pending Transactions Methods
    getMomoPendingTransactions(params: any): Observable<any> {
        let httpParams = new HttpParams();
        Object.keys(params).forEach(key => {
            if (params[key]) {
                httpParams = httpParams.set(key, params[key]);
            }
        });
        return this.http.get(`${environment.API_URL2}/xas/v1/merchant/transactions/pending/momo/transactions`, { params: httpParams });
    }

    getPosPendingTransactions(params: any): Observable<any> {
        let httpParams = new HttpParams();
        Object.keys(params).forEach(key => {
            if (params[key]) {
                httpParams = httpParams.set(key, params[key]);
            }
        });
        return this.http.get(`${environment.API_URL2}/xas/v1/merchant/transactions/pending/pos/transactions`, { params: httpParams });
    }

    getCardPendingTransactions(merchantId: string, params: any): Observable<any> {
        let httpParams = new HttpParams();
        Object.keys(params).forEach(key => {
            if (params[key]) {
                httpParams = httpParams.set(key, params[key]);
            }
        });
        return this.http.get(`${environment.API_URL2}/transactions-service/mastercard/transactions/${merchantId}/pending`, { params: httpParams });
    }
}
